import Container from 'react-bootstrap/Container';
// import Button from 'react-bootstrap/Button';
// import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';

import { useNavigate, useLocation } from "react-router-dom";

import { useEffect, useState } from 'react';

function NavAndSearch() {

  const navigate = useNavigate()
  const location = useLocation();

  const [tablebg, setTableBg] = useState({})
  const [formbg, setFormBg] = useState({})
  const [calcbg, setCalcBg] = useState({})

  useEffect(() => {

    const navbg = {
      backgroundColor: 'rgb(79,113,234)',
      color: '#E8EBED'
    }

    if (location.pathname === '/') {
      setTableBg(navbg)
      setFormBg({})
      setCalcBg({})
    } else if (location.pathname === '/formview') {
      setTableBg({})
      setFormBg(navbg)
      setCalcBg({})
    } else if (location.pathname === '/cbratio') {
      setTableBg({})
      setFormBg({})
      setCalcBg(navbg)
    }
  }, [location])

  return (
    <Navbar bg="light" expand="lg" fixed='top'>
      <Container fluid>
        <Navbar.Brand href="#">PD App Mapping</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            variant="pills"
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            <Nav.Link onClick={() => navigate('/')} style={tablebg}>Table View</Nav.Link>
            <Nav.Link onClick={() => navigate('/formview')} style={formbg}>Form View</Nav.Link>
            <Nav.Link onClick={() => navigate('/cbratio')} style={calcbg}>CB Ratio</Nav.Link>
            {/* <NavDropdown title="Link" id="navbarScrollingDropdown">
              <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action4">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action5">
                Something else here
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#" disabled>
              Link
            </Nav.Link> */}
          </Nav>
          {/* <Form className="d-flex">
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
            />
            <Button variant="outline-success">Search</Button>
          </Form> */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavAndSearch;